module.exports = __webpack_public_path__ + "static/media/arcor.709cb09e.jfif";